define(function (require) {
    "use strict";

    var template = require("personalization-templates/PersonalizationModuleLayout.tmpl");
    var Loader = require("ui/loader/Loader");

    var PersonalizationModuleLayout = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        PersonalizationModuleLayout = Marionette.Layout.extend({
            template: template,
            className: "personalization",
            regions: {
                mainRegion: ".personalization-main-region"
            },
            ui: {
                personalizationMainRegion: ".personalization-main-region"
            },
            modelEvents: {
                "change:isOpen": "_onIsOpenChange"
            },
            withUIComponents: true,
            personalizationLoaderId: "personalizationLoader",

            setLoader: function () {

                this._getLoader().render();
            },
            closeLoader: function () {
                this._getLoader().close();
            },
            _getLoader: function () {
                if (!this.personalizationLoader) {
                    this.personalizationLoader = new Loader({
                        permutation: Loader.PERMUTATION.M,
                        el: this.ui.personalizationMainRegion,
                        zIndex: 1000
                    });
                }
                return this.personalizationLoader;
            },
            _onIsOpenChange: function (model, isOpen) {
                if (isOpen) {
                    this.ui.personalizationMainRegion.removeClass("hide");
                }
                else {
                    this.ui.personalizationMainRegion.addClass("hide");
                    this.closeLoader();
                }
            }
        });

    });
    return PersonalizationModuleLayout;
});